import { createReducer, on } from '@ngrx/store';
import { lifeCycleActions } from '../life-cycle/life-cycle.actions';
import { StoreUser } from './models/store-user';
import { usersActions } from './users.actions';
import { initialUsersState } from './users.state';

// A user known only through a public profile has no license information yet
const unknownClientUserData = {
  isInvited: false,
  mailAddress: '',
  licenseState: null,
  licenseId: null,
};

const indexUsersById = <T extends { id: number }>(
  users: T[],
  initial: { [userId: number]: StoreUser },
): { [userId: number]: StoreUser } => {
  const indexedUsers = { ...initial };

  users.forEach((user) => {
    indexedUsers[user.id] = {
      ...unknownClientUserData,
      ...indexedUsers[user.id],
      ...user,
    } as StoreUser;
  });

  return indexedUsers;
};

export const usersReducer = createReducer(
  initialUsersState,

  on(lifeCycleActions.resetState, () => initialUsersState),

  on(usersActions.addUsersSuccess, (state, { clientUsers }) => ({
    ...state,
    users: indexUsersById(clientUsers, state.users),
  })),

  on(usersActions.updateUsers, (state, { users }) => ({
    ...state,
    users: indexUsersById(users, state.users),
  })),

  on(usersActions.removeUser, (state, { userId }) => {
    const { [userId]: removedUser, ...users } = state.users;
    return {
      ...state,
      users,
    };
  }),
);
